import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Library = createReactComponent("Library", ["svg", defaultAttributes, [["path", {
  d: "M16 6l4 14",
  key: "1dclo4"
}], ["path", {
  d: "M12 6v14",
  key: "13vody"
}], ["path", {
  d: "M8 8v12",
  key: "flrwk9"
}], ["path", {
  d: "M4 4v16",
  key: "41fst9"
}]]]);
export default Library;